import {
  AdapterDateFns,
  DatePicker7,
  GridFilterInputValueProps,
  GridFilterItem,
  GridFilterOperator,
  LocalizationProvider,
} from "@platform/style";
import * as React from "react";
import { format } from "date-fns";

export const CustomDateOperators: GridFilterOperator<any, string>[] = [
  {
    label: "is",
    value: "is",
    getApplyFilterFn: (filterItem) => {
      return applyFilterFn(filterItem);
    },
    InputComponent: InputDateValue,
    InputComponentProps: { type: "Date" },
    getValueAsString: (value: string) => `${value}`,
  },
  {
    label: "after",
    value: "after",
    getApplyFilterFn: (filterItem) => {
      return applyFilterFn(filterItem);
    },
    InputComponent: InputDateValue,
    InputComponentProps: { type: "Date" },
    getValueAsString: (value: string) => `${value}`,
  },
  {
    label: "on or after",
    value: "onOrAfter",
    getApplyFilterFn: (filterItem) => {
      return applyFilterFn(filterItem);
    },
    InputComponent: InputDateValue,
    InputComponentProps: { type: "Date" },
    getValueAsString: (value: string) => `${value}`,
  },
  {
    label: "on or before",
    value: "onOrBefore",
    getApplyFilterFn: (filterItem) => {
      return applyFilterFn(filterItem);
    },
    InputComponent: InputDateValue,
    InputComponentProps: { type: "Date" },
    getValueAsString: (value: string) => `${value}`,
  },
  {
    label: "before",
    value: "before",
    getApplyFilterFn: (filterItem) => {
      return applyFilterFn(filterItem);
    },
    InputComponent: InputDateValue,
    InputComponentProps: { type: "Date" },
    getValueAsString: (value: string) => `${value}`,
  },
];

function applyFilterFn(filterItem: GridFilterItem) {
  if (!filterItem.field || !filterItem.value || !filterItem.operator) {
    return null;
  }

  return (params: any): boolean => {
    return String(params.value) >= String(filterItem.value);
  };
}

function InputDateValue(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const [dateValue, setDateValue] = React.useState<Date | null>(
    item.value ? new Date(item.value + "T00:00:00") : null
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker7
        openTo="day"
        value={dateValue}
        onChange={(newDate) => {
          setDateValue(newDate);
        }}
        onAccept={(selectedNewDate) => {
          selectedNewDate && applyValue({ ...item, value: format(selectedNewDate, "yyyy-MM-dd") });
        }}
        slotProps={{
          textField: {
            variant: "standard",
            sx: { marginTop: "16px", width: "185px" },
            placeholder: "Filter Value",
            onFocus: () => (item.value = ""),
            onBlur: (event: React.FocusEvent<HTMLInputElement>) => {
              const validDate = new Date(event.target.value);
              if (validDate.toString() !== "Invalid Date") {
                applyValue({
                  ...item,
                  value: format(validDate, "yyyy-MM-dd"),
                });
              } else {
                applyValue({
                  ...item,
                  value: undefined,
                });
              }
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}
